import { render, staticRenderFns } from "./StagingBanner.vue?vue&type=template&id=2e9a4b88&"
import script from "./StagingBanner.vue?vue&type=script&lang=js&"
export * from "./StagingBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../root/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports